module.exports = __webpack_public_path__ + "static/media/aviation_digital_brochure.bf3bddb8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brochures/aviation_digital_brochure.pdf
// module id = 308
// module chunks = 0